import React from "react";
import "./AlertInfo.scss";

const AlertInfo = ({ width, icon, content, color, iconPosition }) => {
  return (
    <div className="alert-info-container" style={{ background: color, width: width }}>
      {iconPosition === "left" && icon}
      <div>{content}</div>
      {iconPosition === "right" && icon}
    </div>
  );
};

export default AlertInfo;
